<template>
<div>
  <v-main class="pa-0">
    <div class="d-flex align-center mx-auto mt-6 mb-3" style="width:98%;">
      <v-img class="pa-0" src="../../assets/svg/Ideamenu.svg" alt="" max-width="35px"></v-img>
      <h2>{{$t('アイデア')}}</h2>
      <p class="mr-auto ml-2 mb-0" style="color:#2B2B2B;" v-if="aboutLid" v-text="aboutLid.ideaTheme"></p>
      <v-btn v-if="idealist" @click="idealist = false ,ideadata = true, dataAnalyzeOn=true, mapViewOn=false" class="" color="#008CFF" rounded outlined>統計分析</v-btn>
      <v-btn v-if="ideadata" @click="idealist = true ,ideadata = false, dataAnalyzeOn=false, dataAnalyzeOnNetwork=false,negaPosiOn=false" class="" color="#008CFF" rounded outlined>{{$t('アイデア')}}一覧</v-btn>
    </div>
    <RichViewAndEditor :lidId="$route.params.id" :pageType="$route.name" :foldedByDefault="true"></RichViewAndEditor>
    
    <div class="d-flex mx-auto mt-4 mb-16" style="width:100%;">
      <!--idea-->
      <div class="mx-2 mb-16" style="width:83%">
        <div style="width:96%;">
          <!--地図表示-->
          <!-- <v-btn icon tile @click="mapViewOn=!mapViewOn" height="100" width="100"><v-icon color="blue" size="100">mdi-map </v-icon></v-btn> -->
          <div v-if="mapViewOn" class="mx-auto" style="height:600px; max-width:70vw;">
            <l-map ref="map" @click="addMarker" style="z-index:5 !important;" :zoom="15" :center="[data_location_lat, data_location_lng]">
              <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
              <Vue2LeafletMarkerCluster>
                <l-marker
                  v-for="(ide, index) in showedIdeaInMap" :key="index" :lat-lng="[ide.latlngInputLat, ide.latlngInputLng]" :icon="ide.icon"
                >
                  <l-popup :options="{offset: [3,-26]}">
                    <div class="primary--text">{{ide.content}} ({{ide.timeday}}:{{namelist[ide.author]}})</div>
                    
                <!-- <div v-for="(title, index) in marker.titles"
                    :key="'tit-'+index">
                      <a :href="title.uri" target="_blank">{{title.title}}</a>
                    </div> -->
                  </l-popup>  
                </l-marker>
                
                <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
                <l-marker
                  v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]" :icon="getIconWithColor(place.color, 'pin')"
                >
                  <l-popup :options="{offset: [13,-24]}">
                    <div><h3 class="primary--text">{{place.name}}</h3><p v-if="place.desc" class="body1">{{place.desc}}</p></div>
                  </l-popup>  
                </l-marker>
              </Vue2LeafletMarkerCluster>
            </l-map>
          </div>
          <!-- <v-btn icon tile @click="dataAnalyzeOn=!dataAnalyzeOn" height="100" width="100"><v-icon color="blue" size="100">mdi-chart-bar</v-icon></v-btn> -->
          <MakeWordCloud :key="'word'+Object.keys(showedIdea).length" v-if="dataAnalyzeOn" @showIdeaList="checkSessionStorage(), idealist = true ,ideadata = false, dataAnalyzeOn=false, dataAnalyzeOnNetwork=false,negaPosiOn=false" :lidid="$route.params.id" :word_dict="wordMaps" :height="'700px'" :width="'100%'" :comment="true"> </MakeWordCloud>
          <MakeD3Network v-if="dataAnalyzeOnNetwork" v-bind:words_list="aboutLid.words_list" v-bind:idea="idea" v-bind:word_dict="aboutLid.word_dict" v-bind:edge_dict="aboutLid.edge_dict" :height="'800px'" :force="2000"> </MakeD3Network>
          <MakeNegaPosiChart v-if="negaPosiOn" 
            v-bind:nega_posi_all="aboutLid.nega_posi_all" 
            v-bind:word_dict_posi="aboutLid.word_dict_posi" 
            v-bind:word_dict_nega="aboutLid.word_dict_nega" 
            v-bind:maxposi_cont="aboutLid.maxposi_cont" 
            v-bind:maxnega_cont="aboutLid.maxnega_cont"
            :lidid="$route.params.id"
            height="600" width="1200"
          ></MakeNegaPosiChart>

          <!-- <MakeDownload v-bind:idea="idea" v-bind:namelist="namelist" v-bind:aboutLid="aboutLid"> </MakeDownload>  -->      
        </div>

        <!--各Idea-->
        
        <!-- ideaLoadingがtrueのとき、ローディングバーとスケルトンを表示 -->
        <v-progress-linear v-if="showedIdea.length==0&&ideaLoading" indeterminate color="blue" class="mx-auto"></v-progress-linear>
        <v-row class="mx-0" v-if="showedIdea.length==0&&ideaLoading">
          <v-col class="ideas" :cols="ideaSize" v-for="n in ideaSize*4" :key="`skelton-${n}`">
            <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;">
              <v-card-actions class="pb-8">
                <v-skeleton-loader
                  class="mx-auto"
                  type="chip"
                  height="35"
                ></v-skeleton-loader>
                <v-spacer></v-spacer>
                <v-skeleton-loader
                  class="mx-auto"
                  type="button"
                  height="30"
                ></v-skeleton-loader>
              </v-card-actions>
              <v-card-text class="pa-0">
                <v-skeleton-loader
                  class="mx-5"
                  type="text"
                  height="20"
                ></v-skeleton-loader>
                <v-skeleton-loader
                  class="mx-5"
                  type="text"
                  height="20"
                ></v-skeleton-loader>
                <v-skeleton-loader
                  class="mx-5"
                  width="100"
                  type="text"
                  height="20"
                ></v-skeleton-loader>
              </v-card-text>
              <v-card-actions class="mt-auto pa-0">
                <v-skeleton-loader
                  class="mx-2"
                  type="avatar"
                  height="50"
                ></v-skeleton-loader>
                <v-skeleton-loader
                  class="mr-auto"
                  type="chip"
                  height="35"
                ></v-skeleton-loader>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        
        <!-- アイデアがない時 -->
        <p class="text-center mt-12" :style="{ 'font-size': ideaFontSize }" v-else-if="showedIdea.length==0">まだ{{$t('アイデア')}}が投稿されていません。</p>

        <!-- アイデアがある時 -->
        <v-row class="mx-0" v-if="idealist">
          <!-- 非表示のアイデア（myHiddenIdea）があれば実際のアイデアと併せて表示する -->
          <v-col class="ideas" v-for="(ide,index) in myHiddenIdea.concat(showedIdea)" :key="ide.sort" :cols="ideaSize">  
            <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" :class="ide.isHidden && 'shallowCloud'" outlined elevation="0" height="250" style="border-width: 1.5px; border-color: #707070;">
              <!-- ide.isHiddenの場合、非表示ラベルを重ねて貼る -->
              <v-chip v-if="ide.isHidden" class="shallowCloud" style="position: relative; z-index: 1; margin-top: -20px; margin-left: -20px; color:black; height: 25px; width: 70px;">
                非表示
              </v-chip>
              <!--ideaヘッダー-->
              <v-card-actions class="pa-0">
                <!--ideaタグ-->
                <v-tooltip top v-if="ide.tag&&ide.tag.title">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      style="background-color: #dcdcdc;"
                    >
                      <v-icon :color="ide.tag.color" size="20">mdi-checkbox-blank-circle</v-icon>
                      <p class="mb-0" style="font-size:14px; white-space:nowrap; text-overflow: ellipsis; overflow:hidden;">
                        &nbsp;{{ ide.tag.title }}
                      </p>
                    </v-chip>
                  </template>
                  <span>{{ ide.tag.title }}</span>
                </v-tooltip>
                <v-spacer></v-spacer>
                <v-chip v-if="idea_slider&&ide&&ide.sliderNum&&ide.sliderNum>-100" color="faintHoney" class="white--text">
                  <span>重要度：{{ ide.sliderNum }}</span>
                </v-chip>
                <!-- 職員既読 -->
                <v-tooltip top v-if="govRead&&aboutLid&&aboutLid.readSort&&aboutLid.readSort>ide.sort">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="#008CFF"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-account-check
                    </v-icon>
                  </template>
                  <span>職員が見ました！</span>
                </v-tooltip>
                <v-icon v-if="ide.latlngInputLat&&ide.latlngInputLng" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
                <!--idea編集・削除-->
                <v-menu top v-if="uid === ide.author || aideauids.includes(ide.id)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="" color="#2B2B2B" icon v-bind="attrs" v-on="on" @click="upIdea(ide.id)" style="font-family: mplus-2c-bold;">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pb-0 pt-0">
                    <v-list-item v-if="uid === ide.author || aideauids.includes(ide.id)" @click="deleteIdeaAlert = true" dark style="background-color:#E64550; font-family: mplus-2c-bold;">
                      <v-list-item-title>{{$t('アイデア')}}の削除</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="uid === ide.author || aideauids.includes(ide.id)" @click="doEditIdea(ide)">
                      <v-list-item-title>{{$t('アイデア')}}の編集</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="doQuoteIdea(ide)" v-if="isAuthed&&!ide.isHidden">
                      <v-list-item-title>{{$t('アイデア')}}の引用</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showIdeaDetail(ide)">
                      <v-list-item-title>{{$t('アイデア')}}の詳細</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="isAdmin&&ide.isHidden" @click="unHideIdeaAlert = true" dark style="background-color:#E64550;">
                      <v-list-item-title>{{$t('アイデア')}}を再表示する</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="reportProblemIdea = true, content = ide.content" v-if="false">
                      <v-list-item-title>問題を報告する</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-menu top v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="" color="#2B2B2B" icon v-bind="attrs" v-on="on" @click="upIdea(ide.id)" style="font-family: mplus-2c-bold;">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pb-0 pt-0">
                    <v-list-item @click="doQuoteIdea(ide)" v-if="isAuthed&&!ide.isHidden">
                      <v-list-item-title>{{$t('アイデア')}}の引用</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showIdeaDetail(ide)">
                      <v-list-item-title>{{$t('アイデア')}}の詳細</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="reportProblemIdea = true, content = ide.content" v-if="false">
                      <v-list-item-title>問題を報告する</v-list-item-title>
                    </v-list-item>
                    <!-- isAdminの時のみ、非表示・再表示ボタンも表示する -->
                    <v-list-item v-if="isAdmin&&!ide.isHidden" @click="hideIdeaAlert = true" dark style="background-color:#E64550;">
                      <v-list-item-title>{{$t('アイデア')}}を非表示にする</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="isAdmin&&ide.isHidden" @click="unHideIdeaAlert = true" dark style="background-color:#E64550;">
                      <v-list-item-title>{{$t('アイデア')}}を再表示する</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>
              <!--idea本文-->
              <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 text-left" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
                <div class="mb-0 text-left" style="width:100%;" v-dompurify-html="highlightText(ide.content, searchWord, ide.edit)"></div>
                <div v-if="ide.quotingId" style="width: 100%;">
                  <QuoteBlock :idea="(showedIdea.find(el => el.id === ide.quotingId))" :namelist="namelist" ></QuoteBlock>
                </div>
              </v-card-actions>
              <!--idea画像-->
              <v-img v-if="ide.ideaImage && ide.ideaImage_large" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" @click.native="images=true,dialog_image=ide.ideaImage_large" alt="" class="mx-auto">
              </v-img>
              <v-img v-else-if="ide.ideaImage" contain max-width="100px" max-height="55px"
                :src="ide.ideaImage" @click.native="images=true,dialog_image=ide.ideaImage" alt="" class="mx-auto">
              </v-img>
              <!--ideaフッター-->
              <v-card-actions class="d-flex pa-0 mt-auto">
                <!--idea位置情報・時間-->
                <div v-if="idea_thread">
                  <p class="mb-0" style="color:#2B2B2B !important;"><span v-if="timeday !== ide.timeday">{{ide.timeday}}</span><span v-else>{{ide.timehour}}</span></p>
                </div>
                <div v-if="ide.placename" class="mr-auto">
                  <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{ide.placename}}</p>
                </div>
                <div v-if="!idea_thread" class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;"><span v-if="timeday !== ide.timeday">{{ide.timeday}}</span><span v-else>{{ide.timehour}}</span></p>
                </div>
                <v-btn v-if="idea_thread" class="rounded-pill ml-auto mb-1" color="deepAqua" outlined small @click="showIdeaDetail(ide)">返信<span v-if="ide&&ide.threadNum&&ide.threadNum>0">{{ ide.threadNum }}</span><span v-else>する</span></v-btn>
              </v-card-actions>
              <v-card-actions class="d-flex justify-space-between pa-0">
                <!--idea作者-->
                <div>
                  <div v-if="ide.anonymous||namelist[ide.author]==undefined||namelist[ide.author]==null" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-btn small icon @click="profileUid = ide.author,profile = true"> -->
                    <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                    匿名
                  </div>
                  <div v-else-if="profImageDict[ide.author]==undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <v-btn small icon @click="profileUid = ide.author,profile = true">
                      <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>
                    </v-btn>
                    {{namelist[ide.author]}}
                  </div>
                  <div v-else-if="profImageDict[ide.author]!=undefined && ide.anonymous!=true" style="color:#2B2B2B !important;" class="d-flex">
                    <!-- <v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon> -->
                    <v-btn small icon @click="profileUid = ide.author,profile = true">
                      <v-avatar size="25">
                        <img v-bind:src="profImageDict[ide.author]">
                      </v-avatar>
                    </v-btn>
                    {{namelist[ide.author]}}
                  </div>
                </div>
                <!--ideaいいね-->
                <div v-if="ide.like&&ide.like.length>=0" class="ma-0">
                  <template>
                    <v-btn class="ma-0 rounded-pill" elevation="0"  height="25" width="auto" @click="likecomment(ide.id,index)" :disabled="!isAuthed||!aboutLid.sanka">
                      <v-icon size="25" :color="ide.like.includes(uid) ? 'shallowAqua' : 'shallowCloud'">mdi-thumb-up</v-icon>
                      <v-card-text v-if="uid === ide.author || aideauids.includes(ide.id) || aboutLid.lidAdmin.includes(uid) || isAdmin" class="pa-0">
                        <span :class="ide.like.includes(uid)&&aboutLid.sanka ? 'deepAqua--text' : 'cloud--text'" v-text="ide.like.length"></span>
                      </v-card-text>
                      <v-card-text v-else-if="((ide.like.includes(uid) == false && ide.like.length > 0) || ide.like.length > 1 ) && uid != ide.author" class="pa-0 text-right" style="font-size:10px;">
                        <span :class="ide.like.includes(uid)&&aboutLid.sanka ? 'deepAqua--text' : 'cloud--text'">いいね有</span>
                      </v-card-text>
                    </v-btn>
                  </template>
                </div>
              </v-card-actions>
            </v-card> 
          </v-col>
        </v-row>
        <div class="d-flex mt-4">
          <v-btn class="mx-auto white--text" v-if="idealist&&idea_loadLimit&&(aboutLid.counter&&aboutLid.counter.idea&&aboutLid.counter.idea!=showedIdea.length&&aboutLid.counter.idea>50)&&showedIdea.length>0&&limits<10000" @click="limits = limits + 50,getIdea()" color="deepAqua">さらに読み込む</v-btn>
        </div>
      </div>
      <div class="mt-2 mx-0 d-flex flex-column" style="width:12%; position: fixed; top:20vh; right:5px;">
        <v-btn v-if="idealist" class="mx-auto" style="background-color:white; border:solid #008CFF" icon @click="mapViewOn=!mapViewOn, dataAnalyzeOn=false, dataAnalyzeOnNetwork=false, negaPosiOn=false" height="60" width="60"><v-icon x-large color="#008CFF">mdi-map-marker-radius</v-icon></v-btn>
        <!--idea検索-->
        <v-menu
          v-model="serchc"
          :close-on-click="true"
          :close-on-content-click="false"
          :nudge-width="180"
          offset-x
          z-index="1000"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" style="background-color:white; border:solid #008CFF" icon @click="setgetidea(),serchc=!serchc" height="60" width="60" class="my-2 mx-auto"><v-icon x-large color="#008CFF">mdi-magnify</v-icon></v-btn>
          </template>
          <IdeaSearch
            :ideaList="idea"
            :uid="uid"
            :tags="aboutLid&&aboutLid.tags&&aboutLid.tags.title&&aboutLid.tags.title.some(t=>t.length) ? aboutLid.tags : null"
            @newshowedIdea="newshowedIdea"
            @close="closeSearch"
            @updateSearchWord="(word) => {searchWord = word}"
          ></IdeaSearch>
        </v-menu>

        <!-- idea投稿者の属性で検索 -->
        <v-btn v-if="attributeSearchEnabled" class="mx-auto mb-2" style="background-color:white; border:solid #008CFF" icon @click="attributeSearch=true" height="60" width="60"><v-icon x-large color="#008CFF">mdi-account-search</v-icon></v-btn>
        
        <!--idea並び替え-->
        <v-menu
          v-model="sortc"
          :close-on-click="true"
          :close-on-content-click="false"
          :nudge-width="250"
          offset-x
          v-if="idealist"
          style="z-index: 1000;"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mx-auto" style="background-color:white; border:solid #008CFF" v-bind="attrs" v-on="on" icon @click="setgetidea(),sortc=!sortc" height="60" width="60"><v-icon x-large color="#008CFF">mdi-swap-vertical</v-icon></v-btn>
          </template>
          <IdeaSort v-bind:ideaList="idea" @newshowedIdea="newshowedIdea" @close="closeSort"></IdeaSort>
        </v-menu>
        <v-btn v-if="idealist" :disabled="idea_submitOpen" style="background-color:#008CFF" icon @click.stop="doCreateIdea()" v-on:keydown.enter.enter.exact="doCreateIdea()" height="90" width="90" class="mt-4 mb-2 mx-auto"><v-icon x-large color="white">mdi-pencil-plus</v-icon></v-btn>
        
        <v-btn v-if="ideadata" style="background-color:white; border:solid #008CFF" icon @click="dataAnalyzeOn=true, dataAnalyzeOnNetwork=false, mapViewOn=false, negaPosiOn=false" height="60" width="60" class="my-2 mx-auto"><v-icon x-large color="#008CFF">mdi-format-bold</v-icon></v-btn>
        <v-btn v-if="ideadata" style="background-color:white; border:solid #008CFF" icon @click="dataAnalyzeOnNetwork=true, mapViewOn=false, dataAnalyzeOn=false, negaPosiOn=false" height="60" width="60" class="mx-auto"><v-icon x-large color="#008CFF">mdi-vector-triangle</v-icon></v-btn>
        <v-btn v-if="ideadata" style="background-color:white; border:solid #008CFF" icon @click="negaPosiOn=true,dataAnalyzeOnNetwork=false, mapViewOn=false, dataAnalyzeOn=false" height="60" width="60" class="my-2 mx-auto"><v-icon x-large color="#008CFF">mdi-emoticon</v-icon></v-btn>
        <MakeDownload v-if="ideadata" class="mx-auto" :idea="idea" :namelist="namelist"> </MakeDownload> 
        <MakeShare v-if="ideadata" class="mx-auto" :idea="idea" :namelist="namelist"> </MakeShare> 
        <v-col class="my-8"></v-col>
        <p class="mx-auto mt-4 mb-0">文字サイズ</p>
        <v-speed-dial
          class="mt-0 mx-auto"
          v-model="fab"
          direction="left"
          transition="slide-x-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn
              v-model="fab"
              color="#2b2b2b"
              dark fab
              height="60" width="60"
            >
              <span :style="{ 'font-size': ideaFontSize }" v-if="ideaFontSize == '24px'">大</span>
              <span :style="{ 'font-size': ideaFontSize }" v-if="ideaFontSize == '18px'">中</span>
              <span :style="{ 'font-size': ideaFontSize }" v-if="ideaFontSize == '14px'">小</span>
            </v-btn>
          </template>
          <v-btn class="" small fab @click="ideaFontSize = '24px'" height="40" width="40">大</v-btn> 
          <v-btn class="ma-0" small fab @click="ideaFontSize = '18px'" height="40" width="40">中</v-btn> 
          <v-btn class="" small fab @click="ideaFontSize = '14px'" height="40" width="40">小</v-btn>         
        </v-speed-dial>
      </div>
      <div style="position: fixed; top:20vh; right:1px;">
        <v-slider v-model="ideaSize" thumb-color="red" max="12" min="3" vertical style="max-width:50px !important;" class="my-0" v-if="idealist">
          <template v-slot:append><v-icon @click="increment" color="#2b2b2b">mdi-plus</v-icon></template>
          <template v-slot:prepend><v-icon @click="decrement" color="#2b2b2b">mdi-minus</v-icon></template>
        </v-slider> 
      </div>
    </div>
  </v-main>

  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="profileUid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>

  <!--idea詳細画面-->
  <v-dialog v-model="detailIdeaPage" width="75%" style="height:80vh; overflow:hidden; border: 0px solid black;">
    <v-row class="ma-0 white" style="height:80vh">
      <v-col cols="7" class="pa-0">
        <v-card tile flat class="py-2 overflow-y-auto white" style="max-height:80vh">
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-tooltip top v-if="aboutLid&&aboutLid.readSort&&aboutLid.readSort>detailIdeaContent.sort">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="#008CFF"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-account-check
                  </v-icon>
                </template>
                <span>職員が見ました！</span>
              </v-tooltip>            
          </v-card-actions>
          <!--idea-->
          <v-card-actions class="">
            <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" min-height="150" width="90%" style="border-width: 1.5px; border-color: #707070;">
              <!-- ide.isHiddenの場合、非表示ラベルを重ねて貼る -->
              <v-chip v-if="detailIdeaContent.isHidden" class="shallowCloud" style="position: relative; z-index: 1; margin-top: -20px; margin-left: -20px; color:black; height: 25px; width: 70px;">
                非表示
              </v-chip>
              <!--ideaヘッダー-->
              <v-card-actions class="pa-0">
                <!--ideaタグ-->
                <v-chip v-if="detailIdeaContent.tag&&detailIdeaContent.tag.title" color="#dcdcdc"><v-icon :color="detailIdeaContent.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ detailIdeaContent.tag.title }}</p></v-chip>
                <v-spacer></v-spacer>
                <v-icon v-if="detailIdeaContent.latlngInputLat!=0" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
              </v-card-actions>
              <!--idea本文-->
              <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 mb-auto" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
                <p class="mb-0" style="width:96%;">{{detailIdeaContent.content}}<span class="font-weight-700" style="font-size:10px;" v-if="detailIdeaContent.edit">(編集済み)</span></p>
                <div v-if="detailIdeaContent.quotingId">
                  <QuoteBlock :idea="(showedIdea.find(el => el.id === detailIdeaContent.quotingId))" :namelist="namelist" ></QuoteBlock>
                </div>
              </v-card-actions>
              <!--ideaフッター-->
              <v-card-actions class="d-flex pa-0">
                <!--idea位置情報-->
                <div v-if="detailIdeaContent.placename">
                  <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{detailIdeaContent.placename}}</p>
                </div>
                <!--idea時間-->
                <div v-if="timeday !== detailIdeaContent.timeday" class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{detailIdeaContent.timeday}}</p>
                </div>
                <div v-else class="ml-auto">
                  <p class="mb-0" style="color:#2B2B2B !important;">{{detailIdeaContent.timehour}}</p>
                </div>
              </v-card-actions>
              <v-card-actions class="d-flex justify-space-between pa-0">
                <!--idea作者-->
                <div>
                  <div v-if="detailIdeaContent.anonymous||namelist[detailIdeaContent.author]==undefined||namelist[detailIdeaContent.author]==null" style="color:#2B2B2B !important;" class="d-flex"><v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>匿名</div>
                  <div v-else style="color:#2B2B2B !important;" class="d-flex"><v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>{{namelist[detailIdeaContent.author]}}</div>
                </div>
                <!--ideaいいね-->
                <div v-if="detailIdeaContent.like" class="ma-0">
                  <template v-if="detailIdeaContent.like.includes(uid)">
                    <v-btn class="ma-0 rounded-pill" elevation="3"  height="25" width="auto" disabled>
                      <v-icon size="25" style="color:#008CFF">mdi-thumb-up</v-icon>
                      <v-card-text v-if="uid === detailIdeaContent.author || aideauids.includes(detailIdeaContent.id) || aboutLid.lidAdmin.includes(uid)" class="pa-0" style="color:#008CFF">{{detailIdeaContent.like.length}}</v-card-text>
                      <v-card-text v-if="((detailIdeaContent.like.includes(uid) == false && detailIdeaContent.like.length > 0) || detailIdeaContent.like.length > 1 ) && uid != detailIdeaContent.author" class="pa-0 text-right" style="color:#008CFF; font-size:10px;">いいね有</v-card-text>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn class="ma-0 rounded-pill" elevation="3"  height="25" width="auto" disabled>
                      <v-icon size="25" color="#707070">mdi-thumb-up</v-icon>
                      <v-card-text v-if="uid === detailIdeaContent.author || aideauids.includes(detailIdeaContent.id) || aboutLid.lidAdmin.includes(uid)" class="pa-0" style="color:#707070">{{detailIdeaContent.like.length}}</v-card-text>
                      <v-card-text v-if="((detailIdeaContent.like.includes(uid) == false && detailIdeaContent.like.length > 0) || detailIdeaContent.like.length > 1 ) && uid != detailIdeaContent.author" class="pa-0 text-right" style="color:#707070; font-size:10px;">いいね有</v-card-text>
                    </v-btn>
                  </template>
                </div>
              </v-card-actions>
            </v-card>
          </v-card-actions>
          <v-card-actions v-if="idea_thread" class="d-flex flex-column">
            <h3 class="">{{$t('アイデア')}}の補足説明</h3>
            <v-card flat width="100%">
              <h5 class="mt-4 px-4">
                関連URL
              </h5>
              <v-card-text class="px-6" v-if="links&&links.length>0">
                <v-list-item v-for="(link, i) in links" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>
                      <a :href="`${link.url}`" target="_blank" rel="noopener noreferrer"
                      >{{link.title}}</a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-card-text class="px-6" v-else>
                関連URLは登録されていません
              </v-card-text>

              <h5 class="px-4">
                {{$t('アイデア')}}の補足説明
              </h5>
              <v-card-text class="px-6" v-if="supplement">
                {{supplement}}
              </v-card-text>
              <v-card-text class="px-6" v-else>
                補足説明は登録されていません
              </v-card-text>

              <h5 class="px-4">
                アイデアの位置情報
              </h5>
              <l-map class="my-4" v-if="detailIdeaContent.latlngInputLat&&detailIdeaContent.latlngInputLat!=0" ref="map" @click="addMarkerInput" style="height:300px; width:96%;" :zoom="15" :center="[detailIdeaContent.latlngInputLat, detailIdeaContent.latlngInputLng]">
                <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
                <Vue2LeafletMarkerCluster>
                  <l-marker :lat-lng="[detailIdeaContent.latlngInputLat, detailIdeaContent.latlngInputLng]">
                    <l-popup>
                      <div class="primary--text">位置情報</div>
                      <!-- <div v-for="(title, index) in marker.titles"
                      :key="'tit-'+index">
                        <a :href="title.uri" target="_blank">{{title.title}}</a>
                      </div> -->
                    </l-popup>  
                  </l-marker>
                  <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
                  <l-marker
                    v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]" :icon="getIconWithColor(place.color, 'pin')"
                  >
                    <l-popup :options="{offset: [13,-24]}">
                      <div><h3 class="primary--text">{{place.name}}</h3><p v-if="place.desc" class="body1">{{place.desc}}</p></div>
                    </l-popup>  
                  </l-marker>
                </Vue2LeafletMarkerCluster>
              </l-map>
              <v-card-text class="px-6" v-else>
                位置情報は登録されていません
              </v-card-text>
            </v-card>
            <v-img v-if="ideaImage && ideaImage_large" contain max-width="95%" min-width="30%" :src="ideaImage_large" @click.native="images=true,dialog_image=ideaImage_large" alt="" class="mx-auto"></v-img> 
            <v-img v-else-if="ideaImage" contain max-width="95%" min-width="30%" :src="ideaImage" @click.native="images=true,dialog_image=ideaImage" alt="" class="mx-auto"></v-img>              
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="5" class="pa-0">
        <v-card tile flat class="py-2 overflow-y-auto white" style="max-height:80vh">
          <div style="height:auto;" class="white pa-2 d-flex">
            <h3 class="mb-0" v-if="idea_thread">この{{$t('アイデア')}}に対する返信</h3>
            <v-btn icon tile @click="content='',detailIdeaPage = false" class="ml-auto">
              <v-icon color="#E64550" size="50">mdi-close</v-icon>
            </v-btn>
          </div>
          <chat v-if="idea_thread" contentType="idea" :ideaThreads="ideaThreads" :ideaId="detailIdeaContent.id" @sanka="LidSankaAlert=true"></chat>
          <v-card-actions v-else class="d-flex flex-column">
            <h3 class="">{{$t('アイデア')}}の補足説明</h3>
            <v-card flat width="100%">
              <h5 class="mt-4 px-4">
                関連URL
              </h5>
              <v-card-text class="px-6" v-if="links&&links.length>0">
                <v-list-item v-for="(link, i) in links" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>
                      <a :href="`${link.url}`" target="_blank" rel="noopener noreferrer"
                      >{{link.title}}</a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
              <v-card-text class="px-6" v-else>
                関連URLは登録されていません
              </v-card-text>

              <h5 class="px-4">
                {{$t('アイデア')}}の補足説明
              </h5>
              <v-card-text class="px-6" v-if="supplement">
                {{supplement}}
              </v-card-text>
              <v-card-text class="px-6" v-else>
                補足説明は登録されていません
              </v-card-text>

              <h5 class="px-4">
                アイデアの位置情報
              </h5>
              <l-map class="my-4" v-if="detailIdeaContent.latlngInputLat&&detailIdeaContent.latlngInputLat!=0" ref="map" @click="addMarkerInput" style="height:300px; width:96%;" :zoom="15" :center="[detailIdeaContent.latlngInputLat, detailIdeaContent.latlngInputLng]">
                <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
                <Vue2LeafletMarkerCluster>
                  <l-marker :lat-lng="[detailIdeaContent.latlngInputLat, detailIdeaContent.latlngInputLng]">
                    <l-popup>
                      <div class="primary--text">位置情報</div>
                      <!-- <div v-for="(title, index) in marker.titles"
                      :key="'tit-'+index">
                        <a :href="title.uri" target="_blank">{{title.title}}</a>
                      </div> -->
                    </l-popup>  
                  </l-marker>
                  <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
                  <l-marker
                    v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]" :icon="getIconWithColor(place.color, 'pin')"
                  >
                    <l-popup :options="{offset: [13,-24]}">
                      <div><h3 class="primary--text">{{place.name}}</h3><p v-if="place.desc" class="body1">{{place.desc}}</p></div>
                    </l-popup>  
                  </l-marker>
                </Vue2LeafletMarkerCluster>
              </l-map>
              <v-card-text class="px-6" v-else>
                位置情報は登録されていません
              </v-card-text>
      
        <h5 class="px-4">
          {{$t('プロジェクト')}}への採用
        </h5>
        <v-card-text class="px-6" v-if="detailIdeaContent&&detailIdeaContent.inspires&&detailIdeaContent.inspires.length>0">
          この{{$t('アイデア')}}は{{$t('プロジェクト')}}<span v-for="(inspire,index) in inspires" :key="index">「{{inspire}}」</span>に採用されています。
        </v-card-text>
      </v-card>
            <v-img v-if="ideaImage && ideaImage_large" contain max-width="95%" min-width="30%" :src="ideaImage_large" @click.native="images=true,dialog_image=ideaImage_large" alt="" class="mx-auto"></v-img> 
            <v-img v-else-if="ideaImage" contain max-width="95%" min-width="30%" :src="ideaImage" @click.native="images=true,dialog_image=ideaImage" alt="" class="mx-auto"></v-img>              
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>

  <!--idea問題報告画面-->
  <v-dialog v-model="reportProblemIdea" scrollable max-width="50%" style="z-index:5; width:65%;">
    <v-card>
      
      <v-btn icon tile absolute right @click="reportProblemIdea = false">
        <v-icon color="#E64550" size="50">mdi-close </v-icon>
      </v-btn>
      <v-card-text class="mt-12" text-left style="font-size: 20px;">問題の報告</v-card-text>
      <v-card-text text-left style="font-size: 8px;">{{$t('アイデア')}}の問題報告にあたり、必要事項を入力してください。</v-card-text>
      <v-card-text text-left style="font-size: 16px;">報告内容のカテゴリ</v-card-text>
      <v-card-text text-left style="font-size: 16px;">具体的な報告内容</v-card-text>
      <v-textarea placeholder="報告内容を入力" style="width:90%; border-style: ridge; border-width:2px;" class="ml-8 pl-4"></v-textarea>
      <div>
      <v-btn color="#E64550" rounded outlined style="margin-left:50%; margin-top:3%; margin-bottom:3%;">
        報告
      </v-btn>
      </div>
    </v-card>
  </v-dialog>

  <!--idea投稿画面-->
  <v-dialog
    v-model="createIdeaPage"
    scrollable
    max-width="70%"
    style="z-index:5;"
    @close="clearIdeaTempData"
    @click:outside="clearIdeaTempData"
  >
    <v-card style="overflow:hidden; border: 3px solid black;" outlined color="white">
      <v-card-actions>
        <v-card-text class="font-weght-bold pb-0"><span style="font-size:20px;" class="" v-if="aboutLid" v-text="aboutLid.ideaTheme"></span></v-card-text>
        <v-spacer></v-spacer>
        <v-btn icon tile @click="clearIdeaTempData">
          <v-icon color="#E64550" size="50">mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions style="max-height: 80%;" class="d-flex flex-column overflow-y-auto">
        <v-textarea color="#707070" :placeholder="`${aboutLid.ideaHolder || 'あなたはどう考える？'}（${ideaContentLength}文字以内）`" class="py-1 px-2 ma-4 rounded-xl" rows="6" :rules="idearule" v-model="content" 
        v-on:keydown.enter.ctrl.exact="submit()" counter no-resize style="width:90%; border-style: ridge; border-width:2px;" ></v-textarea>
        <!--引用したメッセージ-->
        <div v-if="isQuoting" class="my-6" style="width:70%;">
          引用しているメッセージ
          <v-card class="mx-auto ma-0 pa-2 d-flex flex-column" outlined elevation="0" height="200" style="border-width: 1.5px; border-color: #707070;">
            <!--ideaヘッダー-->
            <v-card-actions class="pa-0">
              <!--ideaタグ-->
              <v-chip v-if="quotingContent.tag&&quotingContent.tag.title" color="#dcdcdc"><v-icon :color="quotingContent.tag.color" size="20">mdi-checkbox-blank-circle</v-icon><p class="mb-0" style="font-size:14px;">&nbsp;{{ quotingContent.tag.title }}</p></v-chip>
              <v-spacer></v-spacer>
              <v-icon v-if="quotingContent.latlngInputLat!=0" color="rgba(135,206,250,0.5)" size="30">mdi-map</v-icon>
            </v-card-actions>
            <!--idea本文-->
            <v-card-actions color="#2B2B2B" class="d-flex flex-column overflow-y-auto my-0 pt-0 mb-auto" style="height:70%;" :style="{ 'font-size': ideaFontSize }">
              <p class="mb-0">{{quotingContent.content}}<span class="font-weight-700" style="font-size:10px;" v-if="quotingContent.edit">(編集済み)</span></p>
              <div v-if="quotingContent.quotingId">
                <QuoteBlock :idea="(showedIdea.find(el => el.id === quotingContent.quotingId))" :namelist="namelist" ></QuoteBlock>
              </div>
            </v-card-actions>
            <!--ideaフッター-->
            <v-card-actions class="d-flex pa-0">
              <!--idea位置情報-->
              <div v-if="quotingContent.placename">
                <p class="mb-0"><v-icon color="#707070" size="25">mdi-map-marker</v-icon>{{quotingContent.placename}}</p>
              </div>
              <!--idea時間-->
              <div v-if="timeday !== quotingContent.timeday" class="ml-auto">
                <p class="mb-0" style="color:#2B2B2B !important;">{{quotingContent.timeday}}</p>
              </div>
              <div v-else class="ml-auto">
                <p class="mb-0" style="color:#2B2B2B !important;">{{quotingContent.timehour}}</p>
              </div>
            </v-card-actions>
            <v-card-actions class="d-flex justify-space-between pa-0">
              <!--idea作者-->
              <div>
                <div v-if="quotingContent.anonymous||namelist[quotingContent.author]==undefined||namelist[quotingContent.author]==null" style="color:#2B2B2B !important;" class="d-flex"><v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>匿名</div>
                <div v-else style="color:#2B2B2B !important;" class="d-flex"><v-icon size="25" style="color:rgba(128,128,128,0.4)!important;">mdi-account-circle</v-icon>{{namelist[quotingContent.author]}}</div>
              </div>
              <!--ideaいいね-->
              <div v-if="quotingContent.like" class="ma-0">
                <v-card-text v-if="quotingContent.like.length > 0" class="pa-0 text-right" style="color:#008CFF; font-size:10px;">いいね有</v-card-text>
              </div>
            </v-card-actions>

            <!-- idea画像
            <v-img v-if="quotingContent.ideaImage && quotingContent.ideaImage_large" contain max-width="100" max-height="55"
            :src="quotingContent.ideaImage" @click.native="images=true,dialog_image=quotingContent.ideaImage_large" alt="" class="ideaimage_class">
            </v-img> 
            <v-img v-else-if="quotingContent.ideaImage" contain max-width="100" max-height="55"
            :src="quotingContent.ideaImage" @click.native="images=true,dialog_image=quotingContent.ideaImage" alt="" class="ideaimage_class">
            </v-img> -->
          </v-card>
        </div>
        <!--画像投稿-->
        <v-row style="width:100%;">
          <v-col cols="7" class="py-2">          
            <v-select
              class="tagSelect"
              v-if="aboutLid.tags&&aboutLid.tags.title.length"
              v-model="tag"
              :items="aboutLid.tags.title"
              menu-props="{ top: true, offsetY: true }"
              :label="aboutLid.tags.required ? 'ハッシュタグを選択してください' :  'ハッシュタグを選択(任意)'"
              hide-details
              prepend-inner-icon="mdi-circle"
              single-line
              dense
              outlined
              @change="fetchTitle($event)" 
              :color="postcolor"
              :error="aboutLid.tags.required && !tag"
              clearable
            >
            </v-select>
            <!-- <v-select 
              :options="stat.map(g => ({label: g.name, value: g.id}))">
            </v-select> -->
            <v-icon class="mt-4" :color="!!(markers.lat&&markers.lng) ? '#ff0000':'#707070'" size="25">mdi-map-marker </v-icon>
            <span style="font-size:10px; height:20;" v-if="false">({{latlngInput.lat}}, {{latlngInput.lng}})</span>
            <v-btn
              class="mt-4"
              :outlined="!!(markers.lat&&markers.lng)"
              dark
              :color="!!(markers.lat&&markers.lng) ? '#ff0000' : '#399942'"
              rounded
              width="80%"
              @click="ideaplace=true"
            >
              {{markers.lat&&markers.lng ? '位置情報を変更' : '位置情報を登録'}}
            </v-btn>
          </v-col>
          <v-col cols="5" class="py-2">
            <upImage @getImageUrl="getImageUrl" :ideaImageForEdit="ideaImage" class=""></upImage>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-card
          flat
          color="transparent"
          width="100%"
          v-if="idea_slider"
        >
          <v-checkbox
            v-model="sliderIs"
            label="重要度を選ぶ"
            hide-details
          ></v-checkbox>
          <v-subheader>{{ idea_sliderTitle }}</v-subheader>
          <v-card-text class="pt-0">
            <v-slider
              v-model="sliderNum"
              :disabled="!sliderIs"
              step="1"
              :min="1"
              :max="7"
              thumb-label="always"
              ticks="always"
              tick-size="10"
            ></v-slider>
          </v-card-text>
        </v-card>
        <v-btn
          v-if="!createIdeaPageDetail"
          text
          color="#008CFF"
          style="font-size:16px;"
          @click="createIdeaPageDetail = true, ideaInpuHeight ='90vh' "
        >{{$t('アイデア')}}の補足説明・関連リンクを追加
        </v-btn>
        <v-btn 
          v-if="createIdeaPageDetail"
          text
          class="my-4"
          color="#008CFF"
          style="font-size:16px;"
          @click="createIdeaPageDetail = false, ideaInpuHeight ='60vh' "
        >{{$t('アイデア')}}の補足説明・関連リンクを追加しない
        </v-btn>
        <p v-if="createIdeaPageDetail" class="mb-0">{{$t('アイデア')}}に関するURL</p>
        <div v-if="createIdeaPageDetail" class="d-flex flex-column align-center">
          <!-- <v-icon class="mt-0 mb-2" color="#707070" size="25">mdi-link-variant</v-icon>
          <v-text-field v-model="link" label="関連URLを入力(任意)" solo ></v-text-field> -->
          <!-- 「関連URLとそのタイトル」を複数個埋め込めるようにする。モデルはlinksを使う -->
          <div v-for="(link, index) in links" :key="'link-'+index" class="d-flex flex-column align-center">
            <div class="d-flex align-center">
              <v-text-field v-model="link.url" :label="`関連URL${index+1}`" placeholder="https://..." outlined></v-text-field>
              <v-text-field v-model="link.title" :label="`タイトル${index+1}`" placeholder="リンクのタイトルを入力(任意)"  outlined></v-text-field>
              <v-btn icon @click="links.splice(index, 1)" class="mb-5">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-btn @click="links.push({url: '', title: ''})">
            <v-icon>mdi-plus</v-icon>URLを追加
          </v-btn>
        </div>
        <p v-if="createIdeaPageDetail" class="ml-6 mb-0">{{$t('アイデア')}}に関する補足説明</p>
        <div v-if="createIdeaPageDetail" class="mx-auto" style="width:90%">
          <v-textarea color="#707070" placeholder="補足説明を入力" class="py-1 px-2 ma-4" rows="6"
              v-model="supplement" v-on:keydown.enter.ctrl.exact="submit()" counter no-resize style="width:97%; border-style: ridge; border-width:2px;" ></v-textarea>
        </div>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions class="px-4 py-0">
        <v-flex xs12 sm6 md4 text-center my-0><v-switch v-if="!(aboutLid.settings&&aboutLid.settings.postIdeaAnonymous==false)" v-model="isAnonymity" label="匿名で投稿する" class="w-auto" :value="isAnonymity"></v-switch></v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="text-h6 font-weight-bold white--text" 
          color="#008CFF"
          rounded
          x-large
          height="50"
          width="150"
          depressed
          @click="submit()" 
          :disabled="!isSubmittable"
          >
          <!-- editIdeaPageがtrueなら更新、falseなら投稿と表示 -->
          {{ editIdeaPage ? '更新' : '投稿' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--idea位置情報画面-->
  <v-dialog v-model="ideaplace" scrollable max-width="65%" style="z-index:10000; width:65%;">
    <v-card style="overflow:hidden; border: 3px solid black;" outlined color="white" height="80vh">
      <v-card-actions>
          <span style="font-size:30px;" class="title"><v-icon >mdi-map-marker</v-icon>地図をタップしてピンを立てて、地図上にあなたのアイデアを設定しましょう</span>
          <v-spacer></v-spacer>
          <v-btn icon tile @click="ideaplace = false">
              <v-icon color="#E64550" size="50">mdi-close </v-icon>
          </v-btn>
      </v-card-actions>
      <l-map v-if="ideaplace" ref="map" @click="addMarkerInput" style="height:100%; width:100%" :zoom="15"
        :center="markers.lat&&markers.lng ? [markers.lat, markers.lng] : [data_location_lat, data_location_lng]"
      >
        <l-tile-layer :url="'http://{s}.tile.osm.org/{z}/{x}/{y}.png'" :attribution="attribution"></l-tile-layer>
        <Vue2LeafletMarkerCluster>
          <l-marker :lat-lng="[markers.lat, markers.lng]" :icon="getIconWithColor(postcolor)">
            <l-popup :options="{offset: [3,-26]}">
              <div class="primary--text">位置情報</div>
              <!-- <div v-for="(title, index) in marker.titles"
              :key="'tit-'+index">
                <a :href="title.uri" target="_blank">{{title.title}}</a>
              </div> -->
            </l-popup>  
          </l-marker>
          <!-- config.placeLayerに配置した情報提供用の位置情報ピン -->
          <l-marker
            v-for="(place, index) in config.placeLayer" :key="index" :lat-lng="[place.lat, place.lon]" :icon="getIconWithColor(place.color, 'pin')"
          >
            <l-popup :options="{offset: [13,-24]}">
              <div><h3 class="primary--text">{{place.name}}</h3><p v-if="place.desc" class="body1">{{place.desc}}</p></div>
            </l-popup>  
          </l-marker>
        </Vue2LeafletMarkerCluster>   
      </l-map>
      <v-card-actions class="px-4 py-0">
        <!-- <p xs12 sm6 md4 text-center my-5 v-if="latlngInput!={}">({{latlngInput.lat}}, {{latlngInput.lng}})</p> -->
        <v-textarea label="登録する場所に名前をつけましょう" outlined rows="1" row-height="8" v-model="placename" class="text-area2 my-1" hide-details="auto"></v-textarea>
        <v-btn 
          class="text-h6 font-weight-bold white--text" 
          color="#008CFF"
          rounded
          x-large
          height="50"
          width="200"
          depressed
          @click="ideaplace = false"
          >位置情報を設定
        </v-btn>
        <v-btn 
          class="text-h6 font-weight-bold white--text" 
          color="#E64550"
          rounded
          x-large
          height="50"
          width="100"
          depressed
          @click="ideaplace = false, latlngInput.lat = 0, latlngInput.lng = 0"
          :disabled="latlngInput.lat <= 0"
          >削除
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--idea投稿完了画面-->
  <v-dialog v-model="createdIdeaPage" width="800">
    <v-card color="white" elevation="15" class="pt-6">
      <div class="mplus-2c-bold pt-8 px-8 text-h4 text-center">{{$t('アイデア')}}の投稿が完了しました</div>
      <div class="mplus-2c-bold pt-2 px-8 text-h5 text-center">(投稿後も投稿内容を編集できます)</div>
      <v-card-actions class="justify-center pt-4 pb-8" @click="createdIdeaPage = false">
        <v-chip class="px-8" style="font-size:20px;" color="#008CFF" dark>確認</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--idea削除確認画面-->
  <v-dialog v-model="deleteIdeaAlert" width="800">
    <v-card color="white" elevation="15" class="pt-6">
      <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
      <p class="font-weight-bold pt-6 px-8 text-h5 text-center">本当にこの{{$t('アイデア')}}を削除しますか？</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="deleteIdeaAlert = false, deleteIdea()" color="#E64550" dark>削除</v-chip>
        <v-chip class="ma-4 pa-4" @click="deleteIdeaAlert = false" >削除しない</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- idea非表示確認画面 -->
  <v-dialog v-model="hideIdeaAlert" width="800">
    <v-card color="white" elevation="15" class="pt-6">
      <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
      <p class="font-weight-bold pt-6 px-8 text-h5 text-center">本当にこの{{$t('アイデア')}}を非表示にしますか？</p>
      <p class=" px-8 text-center">投稿者は{{$t('アイデア')}}を編集・削除することができます。<br/>編集された場合は再度{{$t('アイデア')}}一覧に表示されます。</p>
      <v-textarea label="非表示事由（投稿者に送信されます）" placeholder="非表示事由をなるべく詳細に記述して下さい。" outlined rows="1" row-height="8" v-model="hideIdeaReason" class="text-area2 my-1 mx-3" hide-details="auto"></v-textarea>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="hideIdeaAlert = false, hideIdea()" color="#E64550" :disabled="!hideIdeaReason" dark>非表示</v-chip>
        <v-chip class="ma-4 pa-4" @click="hideIdeaAlert = false" >表示されたままにする</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- idea再表示確認画面 -->
  <v-dialog v-model="unHideIdeaAlert" width="800">
    <v-card color="white" elevation="15" class="pt-6">
      <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
      <p class="font-weight-bold pt-6 px-8 text-h5 text-center">本当にこの{{$t('アイデア')}}を再表示しますか？</p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="unHideIdeaAlert = false, unHideIdea()" color="#E64550" dark>再表示</v-chip>
        <v-chip class="ma-4 pa-4" @click="unHideIdeaAlert = false" >非表示のままにする</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--idea画像拡大時-->
  <v-dialog v-model="images"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card style="background-color: #212121;">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn x-large fab @click="images=false">
          <v-icon color="#E64550" x-large>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-img contain max-height="80vh" :src="dialog_image" :alt="`${$t('アイデア')}の画像`"></v-img>
    </v-card>
  </v-dialog>

  <!-- attributeSearch -->
  <v-dialog v-model="attributeSearch" v-if="attributeSearchEnabled">
    <v-card class="py-6">
      <FilterByUserAttribute
        class="my-4"
        @updateIdeaIds="(res) => {this.newshowedIdea(this.idea.filter(idea => res.ideaIds.includes(idea.id)))}"
        :lidId="$route.params.id"
      />
    </v-card>
  </v-dialog>

  <!--サインイン画面-->
  <v-dialog v-model="authModal" width="400px" height="60%">
    <auth-view
      v-if="authModal"
      defaultView="chooseauth"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>

  <!--Lid参加確認画面-->
  <v-dialog v-model="LidSankaAlert" width="800">
    <v-card color="white" elevation="15" class="pt-6">
      <v-card-actions class="d-flex justify-center align-center">
        <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
        <div>
          <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
          <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
        </div>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
        <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, this.$store.dispatch('inLid',{lidId:this.$route.params.id,uid:this.uid})" color="deepAqua" dark>参加</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--componets-->
  <activity_function ref="activityfunc"/>

</div>

</template>


<script>
import Vue from 'vue'
import activity_function from '../../components/profile/activity_function.vue';
import RichViewAndEditor from '../../components/RichViewAndEditor.vue';
// import firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'leaflet/dist/leaflet.css'
import { LMap, LIcon, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
import L from 'leaflet';
import VueDOMPurifyHTML from "vue-dompurify-html";
Vue.use(VueDOMPurifyHTML);
// import IdeaSearch from '../../components/idea/IdeaSearch.vue';
// import IdeaSort from '../../components/idea/IdeaSort.vue';
// import upImage from '../../components/upImage.vue'
// import authView from '../../components/auth/authView.vue';
// import MakeWordCloud from '../../components/idea/MakeWordCloud.vue';
// import MakeD3Network from '../../components/idea/MakeD3Network.vue';
// import MakeDownload from '../../components/idea/MakeDownload.vue';
// import MakeShare from '../../components/idea/MakeShare.vue';
// import MakeNegaPosiChart from '../../components/idea/MakeNegaPosiChart.vue';
// import profile_display from "../../components/profile/profile_display.vue";
const FilterByUserAttribute = () => import('../../components/idea/FilterByUserAttribute.vue')
const IdeaSearch = () => import('../../components/idea/IdeaSearch.vue')
const IdeaSort = () => import('../../components/idea/IdeaSort.vue')
const upImage = () => import('../../components/upImage.vue')
const authView = () => import('../../components/auth/authView.vue')
const MakeWordCloud = () => import('../../components/idea/MakeWordCloud.vue')
const MakeD3Network = () => import('../../components/idea/MakeD3Network.vue')
const MakeDownload = () => import('../../components/idea/MakeDownload.vue')
const MakeShare = () => import('../../components/idea/MakeShare.vue')
const MakeNegaPosiChart = () => import('../../components/idea/MakeNegaPosiChart.vue')
const profile_display = () => import('../../components/profile/profile_display.vue')
const chat = () => import('../../components/project/chat.vue')
import QuoteBlock from '../../components/idea/QuoteBlock.vue'

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
  export default {
    components: {
      FilterByUserAttribute,
      upImage,
      IdeaSearch,
      IdeaSort,
      chat,
      LMap, 
      LTileLayer,
      LMarker,
      LPopup,
      MakeWordCloud,
      MakeD3Network,
      MakeDownload,
      MakeShare,
      activity_function,
      RichViewAndEditor,
      QuoteBlock,
      MakeNegaPosiChart,
      authView,
      profile_display,
      Vue2LeafletMarkerCluster
    },
    data: (vm) => ({
      createIdeaPage:  vm.createIdeaInject,
      createdIdeaPage:  vm.createdIdeaInject,
      editIdeaPage: vm.editIdeaInject,
      reportProblemIdea: vm.reportProblemIdea,
      detailIdeaPage: vm.detailIdeaPage,
      deleteIdeaAlert: vm.deleteIdeaInject,
      hideIdeaAlert: vm.hideIdeaInject,
      hideIdeaReason: vm.hideIdeaReasonInject,
      unHideIdeaAlert: vm.unHideIdeaInject,
      createIdeaPageDetail:   vm.createIdeaPageDetail,
      ideauid: null,
      ideauids:[],
      ideaThreads:[],
      ideaThreaduids:[],
      aideauids:[],
      athreads:[],
      ideaContentLength: Number(process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || '110'),
      idearule: [v => v.length <= Number(process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || '110') || `[エラー]入力は${Number(process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || '110')}文字までです`],
      db : null, // created で初期化
      content: "", // アイデアを入力した時に v-model でデータを保存
      placename: vm.placenameInject,
      supplement: "",
      links: [],
      idea : [], // 全件取得した時に全件分のデータを入れる
      num : 0,
      todayy: null,
      timeday: null,
      timehour: null,
      ideaImage: '',
      ideaImage_large: '',
      ideaSize: 4,
      postcolor: '',
      isAnonymity: false,
      LidSankaAlert: false,
      images: false,
      attributeSearch: false,
      ideadata: false,
      idealist: true,
      sortc: false,
      serchc: false,
      keyword:'',
      dialog_image: '',
      hoge: "",
      showedIdea:[],
      myHiddenIdea: [],
      ideaLoading: true,
      limits: 50,
      tag:'',
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      ideaplace: false,
      mapViewOn: false,
      data_location_lat: Number(process.env.VUE_APP_LOCATION_LAT || 35.6813320349034),
      data_location_lng: Number(process.env.VUE_APP_LOCATION_LNG || 139.76716771167693),
      latlngInput: {lat: 0, lng: 0},
      markers: {
        lat: 0,
        lng: 0
      },
      dataAnalyzeOn: false,
      dataAnalyzeOnNetwork: false,
      negaPosiOn: false,
      words_list: [],
      word_dict: {},
      nega_posi_all: {},
      edge_dict: {},
      result_print:false,
      ideaFontSize:"18px",
      ideaInpuHeight:"60vh",
      quotingId: '',
      quotingContent: {},
      detailIdeaContent: {},
      quotingName: '',
      author: '',
      fab: false,
      isQuoting: false,
      authModal: false,
      profImageDict: {},
      profile: false,
      profileUid: "",
      govRead: process.env.VUE_APP_FEATURE_GOV_READ === '1',
      idea_loadLimit: false,
      setallidea: true,
      searchWord: '',
      sliderIs: false,
      sliderNum:4,
      isQueryOpen: true,
      inspires: [],
    }),
    inject: { 
      createIdeaInject :{default : false},
      editIdeaInject :{default : false},
      deleteIdeaInject :{default : false},
      placenameInject :{default : ''},
      createIdeaPageDetail  :{default : false},
      createdIdeaPage  :{default : false},
    },
    computed: {
      wordMaps() {
        // TODO: 検討まだ読み込まれてなければ空を返すとかもあり
        // this.showedIdeaの各each_contents_dictのmapを取り出して、同じキーの値は足し合わせた辞書を返す
        if (!this.showedIdea?.length) {
          return this.aboutLid.word_dict;
        }
        let ideaMap = {}
        this.showedIdea.forEach(idea => {
          if (idea.each_contents_dict) {
            Object.keys(idea.each_contents_dict).forEach(key => {
              if (ideaMap[key]) {
                ideaMap[key] += idea.each_contents_dict[key]
              } else {
                ideaMap[key] = idea.each_contents_dict[key]
              }
            })
          }
        })
        return ideaMap
      },
      setting(){
        return this.$store.state.setting
      },
      members(){
        return this.$store.state.members
      },
      namelist(){
        return this.$store.state.namelist
      },
      isAdmin(){
        return this.$store.state.isAdmin
      },
      config(){
        return this.$store.state.config
      },
      aboutLid(){
        return this.$store.state.aboutLid
      },
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      attributeSearchEnabled() {
        return this.isAdmin && Object.keys(this.$store.state?.auth?.data?.attributionDef)?.length > 0 || false;
      },
      currentName() {
        return this.$store.state.auth.user.displayName;
      },
      isAuthed() {
        return this.$store.state.auth?.isAuthed;
      },
      showedIdeaInMap() {
        let showedIdeaInMap_dict =[]
        for (let i = 0; i < this.showedIdea.length; i++){
          if(this.showedIdea[i].latlngInputLat!=0){
            showedIdeaInMap_dict.push({
              ...this.showedIdea[i],
              icon: this.getIconWithColor(this.showedIdea[i].postcolor)
            })
          }
        }
        return showedIdeaInMap_dict;
      },
      // アイデア投稿可能条件を満たしているかどうか
      isSubmittable() {
        return (
          this.isAuthed &&
          this.content.length >= 1 &&
          this.content.length <= this.ideaContentLength &&
          (!this.aboutLid.tags || !this.aboutLid.tags.required || this.tag)
        )
      },
      admins(){
        return this.$store.state.admins
      },
      idea_submitOpen(){
        if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_submitOpen) return this.$store.state.config.setting.idea_submitOpen
        else return false
      },
      idea_slider(){
        if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_slider) return this.$store.state.config.setting.idea_slider
        else return false
      },
      idea_thread(){
        if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_thread&&this.aboutLid&&this.aboutLid.settings&&this.aboutLid.settings.isOpenIdeaThread) return true
        else return false
      },
      idea_sliderTitle(){
        if(this.$store.state.config.setting&&this.$store.state.config.setting.idea_sliderTitle) return this.$store.state.config.setting.idea_sliderTitle
        else return ""
      },
    },
    watch:{
      detailIdeaPage:{
        handler() {
          // resizeする
          setTimeout(function () {
              window.dispatchEvent(new Event('resize'));
          }, 10);
        }
      },
      ideaplace: {
        handler() {
          // resizeする
          setTimeout(function () {
              window.dispatchEvent(new Event('resize'));
          }, 10);
        }
      },
      ideaLoading: 'checkSessionStorage',
    },
    created() {
      this.db = firebase.firestore(); // dbインスタンスを初期化
      this.today();
      window.addEventListener("beforeunload", this.confirmSave);
    },
    mounted() {
      this.getIconDict()
      this.setLocate()
      this.getConfig()
      //console.log("setting", this.$store.state.setting,this.$store.state.setting.idea_loadLimit, typeof this.$store.state.setting.idea_loadLimit)
      this.setSetting({key: 'idea_loadLimit', value: this.$store.state.setting.idea_loadLimit})
      if (this.isAuthed) this.$store.dispatch('setIdeaRead', this.$route.params.id)
      // anonymousbtnのvalueを、0/lidId ドキュメントのsettings.postIdeaAnonymousを参照して取得
      this.db.collection("0").doc(this.$route.params.id).get()
        .then((doc) => {
          if (doc.exists) {
            this.anonymousbtn = doc.data().settings?.postIdeaAnonymous || false;
          }
        });
    },
    destroyed() {
      window.removeEventListener("beforeunload", this.confirmSave);
    },
    methods: {
      confirmSave(event) {
        if (this.createIdeaPage && this.content.length > 0) {
          event.returnValue = "このページから移動しますか？";
        }
      },
      highlightText(text, searchWord, isEdited) {
        if (!searchWord) return text
        const regex = new RegExp(searchWord, 'gi')
        let out = text.replace(regex, (match) => `<span style="background-color:yellow;">${match}</span>`)
        if (isEdited) out += `<span class="font-weight-700" style="font-size:10px;">(編集済み)</span>`
        return out
      },
      checkSessionStorage(){
        const searchWord = sessionStorage.getItem('searchWord')
        if(searchWord){
          this.searchWord = searchWord
          this.serchc = true
        }
      },
      linksParser(links) {
        // linkのurlが存在し、かつ安全かどうかをチェック
        return links.map((link)=>{
          return {
            ...link,
            url: link.url&&/^https?:/.test(link.url) ? link.url : `https://${link.url}`
          }
        }).filter((link) =>  /^https?:/.test(new URL(link.url).protocol)) || []
      },
      setgetidea(){
        //this.idea_loadLimit = false
        if(this.idea_loadLimit){
          this.limits = 10000
          if(this.setallidea){
            this.ideauids = []
            this.getIdea()
          }
          this.setallidea = false          
        }
      },
      setSetting(el){
        if(el.key==="idea_loadLimit"){
          this.idea_loadLimit = el.value
        }
      },
      getConfig(){
        let self = this
        let collectionA = this.db.collection("0").doc("config")
        collectionA.get().then((doc) => {
          //console.log("Config data:", doc.data());
          if(doc.data().setting&&doc.data().setting.idea_loadLimit){
            self.idea_loadLimit = doc.data().setting.idea_loadLimit
          }
          this.getIdea()
        }).catch((error) => {
          console.log("getConfig getting document:", error);
        });
      },
      setMap(){
        if(this.detailIdeaContent.latlngInputLat!=0){
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 10);   
          console.log("setmap")       
        }
      },
      doCreateIdea(){
        this.clearIdeaTempData()
        if(!this.isAuthed) {
          this.authModal = true
        }        
        else if(!this.aboutLid.sanka){
          this.LidSankaAlert = true
        }
        else{
          this.ideaImage = ""
          this.createIdeaPage = true          
        }
      },
      doEditIdea(ide) {
        this.clearIdeaTempData()
        this.editIdeaPage = true
        this.createIdeaPage = true
        this.content = ide.content
        this.isAnonymity = ide.anonymous

        // タグ
        this.tag = ide.tag.title
        this.fetchTitle(ide.tag.title)

        // 画像
        if (ide.ideaImage) {
          this.ideaImage = ide.ideaImage
          this.ideaImage_large = ide.ideaImage_large
        } else {
          this.ideaImage = ''
          this.ideaImage_large = ''
        }

        // 位置情報
        this.placename = ide.placename
        this.latlngInput.lat = ide.latlngInputLat || 0
        this.latlngInput.lng = ide.latlngInputLng || 0
        this.markers.lat = ide.latlngInputLat || 0
        this.markers.lng = ide.latlngInputLng || 0

        // 引用のための処理
        const quotingIdea = (this.showedIdea.find(el => el.id === ide.quotingId))
        if (quotingIdea) {
          this.isQuoting=true
          this.quotingContent = quotingIdea
          this.quotingName = quotingIdea.anonymous ? 'xxxxx':this.namelist[quotingIdea.author]
          this.quotingId = quotingIdea.id
        }

        // リンク
        this.links = this.linksParser(ide.links ? ide.links : ide.link ? [{title:ide.link, url:ide.link}]: [])

        // 補足説明
        this.supplement = ide.supplement

        this.sliderNum = 4
        this.sliderIs = false
      },
      doQuoteIdea(ide) {
        this.clearIdeaTempData()
        this.content=''
        this.isQuoting=true
        this.quotingContent = ide
        this.quotingName = ide.anonymous ? 'xxxxx': ide.author ? this.namelist[ide.author] : ''
        this.quotingId = ide.id
        this.createIdeaPage = true
      },
      clearIdeaTempData(doAlert=false) {
        // アイデア送信後・アイデア編集後・または投稿キャンセル時に呼び出す
        this.createIdeaPage = false
        this.editIdeaPage = false
        this.content=''
        this.postcolor=''
        this.isQuoting = false;
        this.quotingId = '';
        this.quotingContent={}
        this.quotingName=''
        this.placename = '';
        this.supplement = '';
        this.links.splice(0, this.links.length)
        this.tag='';
        this.detailIdeaContent = {};
        this.detailIdeaPage = false
        this.author = '';
        this.ideaImage = null
        this.ideaImage_large = null
        this.latlngInput.lat=0
        this.latlngInput.lng=0
        this.markers.lat=0
        this.markers.lng=0
        this.sliderNum = 4
        this.sliderIs = false
      },
      showIdeaDetail(ide) {
        if(this.idea_thread) this.getIdeaThreads(ide)
        this.detailIdeaPage = true
        this.detailIdeaContent = ide
        this.content = ide.content
        this.author = this.namelist[ide.author]
        this.placename = ide.placename
        this.supplement = ide.supplement
        this.ideaImage_large = ide.ideaImage_large
        this.ideaImage = ide.ideaImage
        this.links = this.linksParser(ide.links ? ide.links : ide.link ? [{title:ide.link, url:ide.link}]: [])
        if(ide.inspires) this.getProjectsTitle(ide.inspires)
      },
      getProjectsTitle(pjs){
        let self = this
        this.inspires = []
        pjs.forEach((el) => {
          this.db.collection("0").doc(this.$route.params.id).collection("project").doc(el).get().then((doc) => {
            if (doc.exists) {
              //console.log("このアイデアは"+doc.data().title+"に採用されています。")
              self.inspires.push(doc.data().title)
            } else {
              // doc.data() will be undefined in this case
              //console.log("No such document!");
            }
          }).catch((error) => {
            //console.log("Error getting document:", error);
          });          
        })
      },
      getIdeaThreads(ide){
        this.ideaThreads = []
        this.ideaThreaduids = []
        let self = this
        let collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").doc(ide.id).collection("thread")
        collection.where("isActive", "==", true).orderBy("sort","asc").onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            //console.log("ideaThread",change.doc.exists)
            const isNew = self.ideaThreaduids.includes(change.doc.id)
            const isMe = self.athreads.includes(change.doc.id)
            const thread = change.doc.data()
            self.$set(thread, "id", change.doc.id)
            if(isMe) self.$set(thread, "author", self.uid)
            if (change.type === "added") {
              if(isNew) console.log("アイデアスレッド二重登録",thread)
              else{
                //console.log("アイデアスレッド登録",thread)
                self.ideaThreads.push(thread)
                self.ideaThreaduids.push(change.doc.id)
              }
            }
            if (change.type === "modified") {
              //console.log("modified",thread)
              const isNew = self.ideaThreads.some(el => el.id === change.doc.id)
              if(isNew){
                let cmindex = self.ideaThreads.findIndex((el)=>el.id===change.doc.id)
                self.ideaThreads.splice(cmindex,1,thread) //変更処理
                //console.log(cmindex,"Modified: ", self.ideaThreads[cmindex])
              }
            }
            if (change.type === "removed") {
              //console.log("removeed",thread)
              self.ideaThreads.splice(self.ideaThreads.findIndex(el => el.id === change.doc.id), 1)
              self.ideaThreaduids.splice(self.ideaThreaduids.findIndex(el => el === change.doc.id), 1)
            }
          })
        })
      },
      closeProfile() {
        this.profile = false;
      },
      getIconDict() {
        let collection = this.db.collection("0").doc("config").collection("members")
        let self = this
        collection.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            // console.log("icon: ", change.doc.data().uid,change.doc.data().profImageS)
            if (change.doc.data().profImageS != "") self.profImageDict[change.doc.data().uid] = change.doc.data().profImageS;
          })
        });
        // console.log(this.profImageDict)
      },
      closeAuthModal() {
        this.authModal = false
      },
      fetchTitle (event) {
        if (event) {
          this.postcolor = !this.aboutLid?.tags ? '' : this.aboutLid.tags.color[this.aboutLid.tags.title.findIndex(el => el == event)]
        } else {
          this.postcolor = ''
        }
        //console.log(event,this.aboutLid.tags,this.postcolor);
      },
      decrement(){
        this.ideaSize--
      },
      increment (){
        this.ideaSize++
      },
      // onScroll (e) { //スクロール
      //   this.offsetTop = e.target.scrollTop
      // },
      addMarkerInput(event) {
        //console.log(event.latlng);
        this.latlngInput = event.latlng;
        //console.log(this.latlngInput);
        this.markers = this.latlngInput;
        //console.log(this.markers.lat);
      },
      addMarker(event) {
        //console.log(event.latlng)
        //this.markers.push(event.latlng);
      },
      getIconWithColor(tagColor, iconType='flag') {
        const color = tagColor || '#126fc6';
        const icon = L.divIcon({
          html: 
            iconType == 'flag'
            ?
              `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="_x32_" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><rect x="144" class="st0" width="320" height="240" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/><rect x="48" class="st0" width="64" height="512" style="fill: ${color}" stroke="white" stroke-width="20" stroke-linecap="round""/></g></svg>`
            :
              `<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="width: 32px; height: 32px; opacity: 1;" xml:space="preserve"><g><path class="st0" d="M256.102,275.689c-13.136,0-26.131-2.015-38.62-5.994l-2.073-0.66v203.275c0,5.792,2.199,11.289,6.227,15.512 l17.453,17.216c4.276,4.488,10.047,6.96,16.246,6.96c6.202,0,11.97-2.473,16.211-6.926l17.525-17.286 c3.992-4.192,6.19-9.685,6.19-15.477V269.556l-2.052,0.625C281.193,273.838,268.709,275.689,256.102,275.689z" style="fill: ${color};"></path><path class="st0" d="M255.999,0c-68.961,0-125.063,56.106-125.063,125.069c0,68.959,56.102,125.065,125.063,125.065 s125.065-56.106,125.065-125.065C381.064,56.106,324.96,0,255.999,0z M217.269,126.047c-20.052,0-36.366-16.312-36.366-36.366 c0-20.05,16.314-36.362,36.366-36.362s36.366,16.312,36.366,36.362C253.635,109.735,237.321,126.047,217.269,126.047z" style="fill: ${color};"></path></g></svg>`
            ,
          iconAnchor: [3, 34],
          className: 'dummy' // これがないとデフォルトのleaflet-div-iconが適用されてしまう
        })
        return icon
      },
      newshowedIdea(showedIdea__){
        this.showedIdea = showedIdea__;
        this.$set(this.showedIdea,showedIdea__);
        //console.log("this.showedIdea",showedIdea__);
      },
      getImageUrl(ideaImage, ideaImage_large){
          this.ideaImage = ideaImage;
          this.ideaImage_large = ideaImage_large;
      },
      handleResize() {
        if (window.innerWidth <= 479) {
          this.hoge = true
        } else {
          this.hoge = false
        }
        if (window.innerWidth <= 959) {
          this.ideaSize = 12
        }
        //レスポンス対応用
      },
      created() {
        //レスポンス対応用
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        },
      destroyed() {
        window.removeEventListener('resize', this.handleResize)
      },
      //idea登録
      submit() {
        if (!this.isSubmittable) {
          // アイデア投稿条件を満たしているかどうかを判定
          return
        }
        if (this.editIdeaPage) {
          // アイデアの編集であれば、編集処理を実行
          this.editIdea()
          return
        }
        this.today()
        let self = this, author = "XXXXX", now = new Date().toLocaleString("ja-JP", { timeZone: 'Asia/Tokyo' })
        if(!this.isAnonymity) author = this.uid //匿名でない場合にはauthorにuidを設定
        if(!this.latlngInput.lat){
          //位置情報が登録されていない場合リセットする
          this.latlngInput.lat=0
          this.latlngInput.lng=0
          this.markers.lat=0
          this.markers.lng=0
        }
        this.createIdeaPage = false
        this.db.collection("0").doc(this.$route.params.id).collection("idea").add({
          isActive: true,
          isHidden: false,
          content: this.content,
          placename: this.placename,
          supplement: this.supplement,
          links: this.linksParser(this.links),
          author: author,
          createdAt: now, //firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: now,
          sort: this.todayy,
          inspires: [],
          timeday: this.timeday,
          timehour: this.timehour,
          like: [],
          edit: false,
          ideaImage: this.ideaImage,
          ideaImage_large: this.ideaImage_large,
          postcolor: this.postcolor,
          anonymous: this.isAnonymity,
          quotingId: this.quotingId,
          tag: {
            title: this.tag || '',
            color: this.postcolor
          },
          latlngInputLat: this.latlngInput.lat,
          latlngInputLng: this.latlngInput.lng,
          sliderNum: this.sliderIs ? this.sliderNum : null,
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("Document written with ID: ", docRef.id)
          if(self.isAnonymity){
            self.db.collection("0").doc(self.$route.params.id).collection("aidea").doc(docRef.id).set({
              id: docRef.id,
              author: self.uid,
              currentName: self.currentName,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
              content: self.content
            })
            const aideas = self.db.collection("0").doc(self.$route.params.id).collection("liduser").doc(self.uid).collection("aidea").doc("aideas")
            aideas.set({
              aideas: firebase.firestore.FieldValue.arrayUnion(docRef.id),
            },{merge:true})
            self.aideauids.push(docRef.id)              
          }
          else self.$refs.activityfunc.ideapost(self.$route.params.id,docRef.id,self.content)
          self.createdIdeaPage = true
          self.clearIdeaTempData()
        }).catch(function(error) {
          // 保存に失敗した時
          //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
          console.error("Error adding document:", error);
        })
        try {
          // Slack連携機能
          const feedbackLidId = process.env.VUE_APP_FEEDBACK_LID_ID || ''
          if (feedbackLidId?.split(',').includes(this.$route.params.id)) {
            const gasUrl = process.env.VUE_APP_FEEDBACK_GAS_URL || ''
            if (gasUrl) {
              fetch(`${gasUrl}?uid=${this.uid}&name=${this.currentName}&message=${this.content}&url=${window.location.href}`)
            }
          }
        } catch (e) {
          console.error(e)
        }
      },
      //ideauid取得
      upIdea(id){
        this.ideauid = id
      },
       //いいね機能
      likecomment(id,index){
        let self = this
        //console.log("いいね発動検知"+index,!this.showedIdea[index].like.includes(this.uid),this.showedIdea[index].like)
        if(this.showedIdea[index].like.includes(this.uid)){
          this.showedIdea[index].like.splice(this.showedIdea[index].like.indexOf(this.uid),1) //いいね仮解除
        }
        else this.showedIdea[index].like.push(this.uid) //いいね仮登録
        firebase.functions().httpsCallable('ideaLiked')({
          lidid: self.$route.params.id,
          ideauid: id,
          uid: self.uid,
        })
      },
      //Idea編集
      editIdea(){
        if (!this.isSubmittable) {
          return
        }
        this.editIdeaPage = false
        this.createIdeaPage = false
        this.today()
        let author = "XXXXX", self = this, now = new Date().toLocaleString("ja-JP", { timeZone: 'Asia/Tokyo' })
        if(!this.isAnonymity) author = this.uid //匿名でない場合にはauthorにuidを設定
        if(!this.latlngInput.lat){
          this.latlngInput.lat=0
          this.latlngInput.lng=0
          this.markers.lat=0
          this.markers.lng=0
        }
        this.db.collection("0").doc(this.$route.params.id).collection('idea').doc(this.ideauid).update({
          isActive: true,
          isHidden: false,
          content: this.content,
          placename: this.placename,
          supplement: this.supplement,
          // linkはもう使わないので空にするために上書き
          link: null,
          links: this.linksParser(this.links),
          author: author,
          updatedAt: now, //firebase.firestore.FieldValue.serverTimestamp(),
          timeday: this.timeday,
          timehour: this.timehour,
          edit: true,
          ideaImage: this.ideaImage,
          ideaImage_large: this.ideaImage_large,
          postcolor: this.postcolor,
          anonymous: this.isAnonymity,
          quotingId: this.quotingId,
          tag: {
            title: this.tag || '',
            color: this.postcolor
          },
          latlngInputLat: this.latlngInput.lat,
          latlngInputLng: this.latlngInput.lng,
          sliderNum: this.sliderIs ? this.sliderNum : null,
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("Document written with ID: ", docRef.id)
          if(self.isAnonymity){
            self.db.collection("0").doc(self.$route.params.id).collection("aidea").doc(self.ideauid).set({
              id: self.ideauid,
              author: self.uid,
              currentName: self.currentName,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
              content: self.content
            })
            const aideas = self.db.collection("0").doc(self.$route.params.id).collection("liduser").doc(self.uid).collection("aidea").doc("aideas")
            aideas.set({
              aideas: firebase.firestore.FieldValue.arrayUnion(self.ideauid),
            },{merge:true})
            self.aideauids.push(self.ideauid)
          }
          // this.myHiddenIdeaに、id=ideauidのドキュメントが含まれていた場合は、除去する
          if (self.myHiddenIdea.some(idea => idea.id === self.ideauid)) {
            self.myHiddenIdea = self.myHiddenIdea.filter(idea => idea.id !== self.ideauid)
          }
          self.createdIdeaPage = true
          self.clearIdeaTempData()
        }).catch(function(error) {
          // 保存に失敗した時
          alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
          console.error("Error adding document:", error);
        })
      },
       //Idea削除
      deleteIdea(){
        var self = this
        let now = new Date().toLocaleString("ja-JP", { timeZone: 'Asia/Tokyo' })
        this.db.collection("0").doc(this.$route.params.id).collection('idea').doc(this.ideauid).update({
          isActive: false,
          updatedAt: now //firebase.firestore.FieldValue.serverTimestamp()
        }).then(function(docRef) {
          // 保存に成功した時
          //console.log("Document written with ID: ", docRef.id)
        }).catch(function(error) {
          // 保存に失敗した時
          //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
          console.error("Error adding document:", error);
        })   
      },
      // Idea非表示
      hideIdea(){
        firebase.functions().httpsCallable('hideIdea')({
          lidId: this.$route.params.id,
          ideaId: this.ideauid,
          hideReason: this.hideIdeaReason,
        })
      },
      // Idea非表示解除
      unHideIdea(){
        // 非表示解除の場合は、直接isHiddenをfalseにする
        this.db.collection("0").doc(this.$route.params.id).collection('idea').doc(this.ideauid).update({
          isHidden: false,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        })
      },
      //idea全件取得
      getIdea() {
        // この先にあるthenでthisの参照が切れるのでselfに退避させておく
        let self = this, oneidea = {}
        //console.log("idea取得開始"+this.limits,this.config)
        //console.log("idea取得開始",this.isAuthed)
        this.ideaLoading = true
        this.idea = []
        this.showedIdea = []
        // //console.log("----------", this.$route.params.id)
        // 全件取得する
        let collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).where("isHidden", "==", false).orderBy('sort', 'asc')
        if (this.isAdmin) collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).orderBy('sort', 'asc')
        // if(this.idea_loadLimit) collection = this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).where("isHidden", "!=", true).orderBy('isHidden', 'asc').orderBy('sort', 'desc').limit(this.limits)
        collection.onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            //console.log('IDEAchange: ', change.doc.data())
            let ideaindex
            const isExsist = self.ideauids.includes(change.doc.id)
            oneidea = change.doc.data()
            self.$set(oneidea,"id",change.doc.id)
            if(self.$route.query.id == change.doc.id && self.isQueryOpen){
              self.showIdeaDetail(oneidea)
              self.isQueryOpen = false
            }
            //console.log(oneidea.sort)
            if (change.type === "added") {
              if(isExsist&&!self.idea_loadLimit) console.log("アイデア二重登録") 
              else{
                //console.log("added: ", change.doc.id,oneidea)
                self.idea.push(oneidea)
                self.ideauids.push(change.doc.id)
              }
            }
            if (change.type === "modified") {
              if(isExsist){
                ideaindex = self.ideauids.findIndex((el)=>el===change.doc.id)
                self.idea.splice(ideaindex,1,oneidea)
                //console.log("アイデア修正",ideaindex,"Modified: ", self.idea[ideaindex])
              }
              else{
                console.log("newmodified: ", change.doc.id,oneidea);
                self.idea.push(oneidea)
                self.ideauids.push(change.doc.id)
              }
              
            }
            if (change.type === "removed") {
              //console.log("Removed: ", oneidea)
              ideaindex = self.ideauids.findIndex((el)=>el===change.doc.id)
              self.idea.splice(ideaindex,1)
              self.ideauids.splice(ideaindex,1)
            }
          })
          this.showedIdea = this.idea.slice().reverse()
          if(this.idea_loadLimit) this.showedIdea = this.idea.slice()
          this.ideaLoading = false
        })
        if(this.isAuthed){
          this.getAidea()
          if (!this.isAdmin){
            this.getMyHiddenIdeas()
          }
        }
      },
      getAidea(){
        let self = this
          let collection2 = this.db.collection("0").doc(this.$route.params.id).collection("liduser").doc(self.uid).collection("aidea")
          collection2.onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
              console.log('IDEAchange: ', change.doc.data())
              let isNew = false
              if(change.doc.id) isNew = self.aideauids.includes(change.doc.id)
              if (change.type === "added") {
                if(isNew) console.log("アイデア二重登録")
                else{
                  //console.log("2added: ", change.doc.data().aideas)
                  self.aideauids = change.doc.data().aideas || []
                  self.athreads = change.doc.data().athreads || []
                }
              }
              if (change.type === "modified") {
                //console.log("modified")
              }
              if (change.type === "removed") {
                //console.log("removeed")
              }
            })
            //console.log("aIdeafinish"+self.aideauids);
          })          
      },
      getMyHiddenIdeas() {
        // 非表示のアイデアを追加する
        this.db.collection("0").doc(this.$route.params.id).collection("idea").where("isActive", "==", true).where("isHidden", "==", true).where("author", "==", this.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //console.log(doc.id, " => ", doc.data());
            this.myHiddenIdea.push({...doc.data(), id: doc.id})
          });
        });
        this.db.collection("0").doc(this.$route.params.id).collection("liduser").doc(this.uid).collection("aidea").get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // /0/[lidid]/idea/[doc.id] のisActive=trueかつisHiddenがtrueの場合のみ、非表示アイデアとして追加する
            this.db.collection("0").doc(this.$route.params.id).collection("idea").doc(doc.id).get().then((doc2) => {
              if (doc2.exists) {
                //console.log("Document data:", doc2.data());
                if (doc2.data().isActive && doc2.data().isHidden) {
                  this.myHiddenIdea.push(doc2.data())
                }
              } else {
                // doc.data() will be undefined in this case
                //console.log("No such document!");
              }
            }).catch((error) => {
              //console.log("Error getting document:", error);
            });
          });
        });
      },
      toDoubleDigits(num) {
          num += "";
          if (num.length === 1) {
            num = "0" + num;
          }
        return num; 
      },
      today(){
        // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
        let date = new Date();
        let yyyy = date.getFullYear();
        let mm = this.toDoubleDigits(date.getMonth() + 1)
        let dd = this.toDoubleDigits(date.getDate())
        let hh = this.toDoubleDigits(date.getHours())
        let mi = this.toDoubleDigits(date.getMinutes())
        let se = this.toDoubleDigits(date.getSeconds())
        let ms = this.toDoubleDigits(date.getMilliseconds())
        if(ms.length==2) ms = "0"+ms
        this.todayy = yyyy + mm + dd + hh + mi + se + ms
        this.timeday= mm+"/"+dd
        this.timehour= hh+":"+mi
      },
      closeSort() {
        this.sortc = false
      },
      closeSearch() {
        this.serchc = false
      },
      slider_plus(value){
        value=value+1;
      },
      slider_minus(value){
        value=value--;
      },
      setLocate(){
        if(this.config&&this.config.location){
          this.data_location_lat = this.config.location.lat
          this.data_location_lng = this.config.location.lng
        }
      },
    },
    }
</script>

<style scoped>
.slideX .v-input__control{
  height:100px !important;
}
.black{
  color: #2B2B2B;
}
.defaultcolor{
  background-color: #cce8ff;
}
.redcolor{
  background-color: #ff8796;
}
.greencolor{
  background-color: #b6e3ba;
}
.yellowcolor{
  background-color: #ffb336;
}
*{
  font-family:mplus-2c-medium;
}
p {
  white-space: pre-wrap;
}
.contents > .camera {
  cursor: pointer;
}
.input-item__label {
  cursor: pointer;
}
.input-item__label input[type="file"] {
  display: none;
}
.ideas::-webkit-scrollbar { 
  display: none;
}
/*
.tagSelect >>> .v-input__icon--prepend-inner > i {
  color: rgb(0, 140, 255) !important;
  caret-color: rgb(0, 140, 255) !important;
}
*/
/*====================
PCを基本設計にする
 - 1280px〜：大型PC
 - 960px〜1279px：小型PC
 - 600px〜959px：タブレット
 - 480px〜599px：スマートフォン横
 - 〜479px：スマートフォン縦
====================*/
/* 1280px〜：大型PC
------------------------------ */
@media screen and (min-width:1280px) {
.text-area{
  border-radius: 0.67em;
  position:relative;
  left:4%;
}
.text-areaa{
  border-radius: 0.67em;
}
.title{
  position:relative;
  left:4%;
}
.dog{
  position: absolute;
  top: 20%;
  left: 10%;
}
.ideaimage_class{
  margin-left: auto;
  margin-right: auto;
  top: 50%;
}
.map{
  position: fixed;
  right: 1%;
  top: 36%;
}
}

/* 960px〜1279px：小型PC
------------------------------ */
@media screen and (min-width:960px) and (max-width:1279px){
.text-area{
  border-radius: 0.67em;
}
.dog{
  position: absolute;
  top: 20%;
  left: 10%;
}
.ideaimage_class{
  margin-left: auto;
  margin-right: auto;
  top: 60%;
}
}

/* 600px〜959px：タブレット
------------------------------ */
@media screen and (min-width:600px) and (max-width:959px){

.text-area{
  border-radius: 0.67em;
}
.dog{
  position: absolute;
  top: 20%;
  left: 10%;
}
.ideaimage_class{
  margin-left: auto;
  margin-right: auto;
  top: 60%;
}
}

/* 480px〜599px：SP横
------------------------------ */
@media screen and (min-width:480px) and (max-width:599px){
.dog{
  position: absolute;
  top: 20%;
  left: 10%;
}
.ideaimage_class{
  margin-left: auto;
  margin-right: auto;
  top: 60%;
}
}

@media screen and (max-width:479px) {
.dog{
  position: absolute;
  top: 20%;
  left: 10%;
}
.ideaimage_class{
  margin-left: auto;
  margin-right: auto;
  top: 60%;
}
}

</style>
